import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { FacilityListingComponent } from './components/facility-listing/facility-listing.component';
import { AdminLoginGuard } from './guards/admin-login.guard';
import { FacilityInfoComponent } from './components/facility-info/facility-info.component';
import { CseFacilityMappedComponent } from './components/cse-facility-mapped/cse-facility-mapped.component';

const routes: Routes = [
  { path: '', component: LayoutComponent, canActivate: [AdminLoginGuard] },
  { path: 'facility-listing', component: LayoutComponent, canActivate: [AdminLoginGuard] },
  { path: 'facility-info', component: LayoutComponent, canActivate: [AdminLoginGuard] },
  { path: 'cse-listing', component: LayoutComponent, canActivate: [AdminLoginGuard] },
  { path: 'add-cse-form', component: LayoutComponent, canActivate: [AdminLoginGuard] },
  { path: 'cse-mapped-list', component: LayoutComponent, canActivate: [AdminLoginGuard] },
  { path: 'cse-facility-mapped', component: LayoutComponent, canActivate: [AdminLoginGuard] },
  { path: 'add-mapping-form', component: LayoutComponent, canActivate: [AdminLoginGuard] },
  { path: 'dashboard', component: LayoutComponent, canActivate: [AdminLoginGuard] },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdminRoutingModule { }
